var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMccBakaries(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8369",
    "data-name": "Rectangle 8369",
    width: 28,
    height: 28,
    transform: "translate(390 1788)",
    fill: "#efefef"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8366",
    "data-name": "Rectangle 8366",
    width: 23.803,
    height: 22.72,
    transform: "translate(2.099 2.639)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bakery",
    transform: "translate(-390 -1788)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35214",
    "data-name": "Group 35214",
    transform: "translate(390 1788.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35213",
    "data-name": "Group 35213",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35861",
    "data-name": "Path 35861",
    d: "M24,13.369l-3.4-1.4,4.052-3.378q.576,1.317,1.154,2.633A1.577,1.577,0,0,1,24,13.366",
    fill: "#b3b5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35862",
    "data-name": "Path 35862",
    d: "M11.677,16.987q-2.616-.879-5.306-1.74-2.01-.646-3.992-1.253a8.631,8.631,0,0,0-.245,2.951c.061.666.4,3.5,2.277,4.693a1.688,1.688,0,0,0,.375.194,2.133,2.133,0,0,0,1.689-.472c.018-.012.2-.164.556-.469s.486-.415,1.009-.861c.338-.288.51-.435.684-.581.318-.266.431-.357.751-.621.5-.413.586-.494,1.2-1.01.23-.193.573-.479,1-.83",
    fill: "#b3b5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35863",
    "data-name": "Path 35863",
    d: "M11.714,23.717q-.4-1.794-.8-3.587L6.9,23.555l2.4,1.582a1.577,1.577,0,0,0,2.414-1.42",
    fill: "#b3b5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35864",
    "data-name": "Path 35864",
    d: "M17.262,12.34q-.412-2.726-.792-5.525-.285-2.091-.541-4.148a8.635,8.635,0,0,1,2.946.273c.646.176,3.382,1,4.227,3.057a1.661,1.661,0,0,1,.126.4,2.131,2.131,0,0,1-.758,1.581c-.015.016-.2.166-.558.466s-.493.406-1.023.844c-.343.283-.517.428-.691.573-.318.267-.427.364-.741.631-.494.42-.589.492-1.2,1.01-.229.194-.571.482-.99.84",
    fill: "#b3b5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35865",
    "data-name": "Path 35865",
    d: "M13.864,3.54a.976.976,0,0,0-.129-.2c-.912-1.058-3.955.069-6.8,2.517s-4.4,5.293-3.489,6.351a1.178,1.178,0,0,0,.728.371L12.788,15.4a.932.932,0,0,0,1.009-.121l1.52-1.276a1.09,1.09,0,0,0,.366-1.042q-.858-4.614-1.719-9.223a.184.184,0,0,0-.01-.051V3.677a.409.409,0,0,0-.068-.129c0-.005-.011-.006-.016-.011",
    fill: "#b3b5c4"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMccBakaries);
export default __webpack_public_path__ + "static/media/mcc_bakaries.a509ec51ac2f762ad91de6fc9b72dfbe.svg";
export { ForwardRef as ReactComponent };